/* ============================================================
   BDP — Progresso contínuo do carrossel
   Liga cada .bdp-sprog ao <slider-component> pai: o polegar
   ganha largura = fração visível do trilho e desliza junto com
   o scroll nativo (rAF-throttled). Nada de dependências: escuta
   o mesmo scroll que o slider do Dawn já usa.
   ============================================================ */
(function () {
  'use strict';

  function bind(track) {
    if (track.dataset.bdpBound) return;
    var component = track.closest('slider-component');
    if (!component) return;
    var slider = component.querySelector('.slider');
    var fill = track.querySelector('.bdp-sprog__fill');
    if (!slider || !fill) return;
    track.dataset.bdpBound = 'true';

    var ticking = false;

    function update() {
      ticking = false;
      var total = slider.scrollWidth;
      var visible = slider.clientWidth;
      if (total <= visible) {
        // tudo cabe na tela: sem o que rolar, barra some junto do wrapper
        track.closest('.slider-buttons').style.display = 'none';
        return;
      }
      track.closest('.slider-buttons').style.display = '';
      var trackWidth = track.clientWidth;
      var thumb = Math.max(24, trackWidth * (visible / total));
      var progress = slider.scrollLeft / (total - visible);
      progress = Math.min(1, Math.max(0, progress));
      var x = (trackWidth - thumb) * progress;
      fill.style.width = thumb + 'px';
      fill.style.transform = 'translateX(' + x + 'px)';
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    slider.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(slider);
    }
    update();
  }

  function init() {
    document.querySelectorAll('.bdp-sprog').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // editor de temas: seções recarregam sem reload da página
  document.addEventListener('shopify:section:load', init);
})();
